// extracted by mini-css-extract-plugin
export default {"modal":"SelectDevices_modal__ZeR6T","tips":"SelectDevices_tips__F1Mje"};